module.exports = __webpack_public_path__ + "img/folder-symlink.7e8021b6.svg";